module.exports = __webpack_public_path__ + "static/media/face-man-outline.95b031fd.svg";